import { events } from '../names';
import { useSendEvent } from '../useSendEvent';

type Params = {
	mediaId?: string;
	botClientId: number | string;
};

export const useVideoMessageViewed = ({ mediaId, botClientId }: Params) =>
	useSendEvent(events.video.messageViewed, {
		mediaId,
		bot_UserId: botClientId,
	});

export const usePlayVideoButtonClicked = ({ mediaId, botClientId }: Params) =>
	useSendEvent(events.video.playButtonClicked, {
		mediaId,
		bot_UserId: botClientId,
	});

export const useVideoMessagePlaybackPaused = ({
	mediaId,
	botClientId,
}: Params) =>
	useSendEvent(events.video.playbackPaused, {
		mediaId,
		bot_UserId: botClientId,
	});

export const useVideoMessagePlaybackStarted = ({
	mediaId,
	botClientId,
}: Params) =>
	useSendEvent(events.video.playbackStarted, {
		mediaId,
		bot_UserId: botClientId,
	});

export const useVideoMessagePlaybackResumed = ({
	mediaId,
	botClientId,
}: Params) =>
	useSendEvent(events.video.playbackResumed, {
		mediaId,
		bot_UserId: botClientId,
	});

export const useVideoMessagePlaybackCompleted = ({
	mediaId,
	botClientId,
}: Params) =>
	useSendEvent(events.video.playbackCompleted, {
		mediaId,
		bot_UserId: botClientId,
	});
